import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@mui/styles';
import { InputLabel, MenuItem, FormControl, Select, Typography } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';
import { PapiroConsole } from '../../../../utils/papiroConsole';

const StyledOutlinedInput = styled(OutlinedInput)`
  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }
  & .MuiOutlinedInput-notchedOutline legend {
    display: none;
  }
  & .MuiOutlinedInput-notchedOutline:hover {
    border: none;
  }
  & .MuiInputLabel-root {
    color: #FFF;
  }
  & .MuiOutlinedInput-input {
    font-size: 1em;
    padding: 0 28px 0 0 !important;
    color: #000;
    display: flex;
    align-items: center;
  }
  & .MuiOutlinedInput-root {
    background-color: #FFF;
    border: none;
    border-radius: 20px
  }
  & .MuiOutlinedInput-root .Mui-focused {
    border: none;
  }
  & .MuiInputBase-colorPrimary {
    border: none;
  }
`;

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 160,
    fullWidth: true,
    display: 'flex',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function SimpleSelectWithConfirmationColor(props) {

  const { label, options, stateName, changeSelect, selected, required, disabled, fullWidth, newStatusValue, isMobile } = props;

  PapiroConsole.log(options)
  PapiroConsole.log("options new")
  PapiroConsole.log(selected)
  PapiroConsole.log("selected")



  const classes = useStyles();
  const [option, setOption] = React.useState(selected ? selected : 0);




  const inputLabel = React.useRef(null);
  const [labelwidth, setLabelWidth] = React.useState(0);

  React.useEffect(() => {
    //setLabelWidth(inputLabel.current.offsetWidth);
    PapiroConsole.log("entrei no useeffect")
    setOption(selected ? selected : 0);
  }, [selected]);

  /*React.useEffect(() => {
    PapiroConsole.log("entrei no useeffect 2 ")
    setOption(newStatusValue && newStatusValue!= 0 ? newStatusValue : selected);
  }, [newStatusValue]);*/

  const handleChange = event => {
    //setOption(event.target.value);
    changeSelect(stateName, event.target.value);
  };

  const changeConfirmation = (value) => {
    setOption(value);
  };



  return (
    <div>
      <FormControl required={required} variant="outlined" className={classes.formControl}
        disabled={disabled} fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">
          {label}
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={option}
          onChange={handleChange}
          required
          input={<StyledOutlinedInput />}
          renderValue={(selected) => {
            const selectedItem = options.find((item) => item.id === selected);
            if (!selectedItem) return '';

            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  className="m-item-color"
                  style={{
                    backgroundColor: selectedItem.colorhex,
                    width: 15,
                    height: 15,
                    borderRadius: 5,
                    float: 'left',
                  }}
                />
                <Typography
                  variant="inherit"
                  noWrap
                  style={{ paddingLeft: 5, fontSize: '1.1em' }}
                >
                  {selectedItem.title ? selectedItem.title : selectedItem.name}
                </Typography>
              </div>
            );
          }}
        >


          {options && options.map(item => {
            if (item.enable == false) {
              return <MenuItem key={item.id} value={item.id} disabled={!item.enable} sx={{ display: 'flex', alignItems: 'center' }} >
                <div className='m-item-color' style={{ backgroundColor: item.colorhex, width: isMobile ? 15 : 5, height: 15, borderRadius: 5, float: 'left' }}></div>
                <Typography variant='inherit' noWrap style={{ paddingLeft: 5, fontSize: '1.1em' }}>{item.title ? item.title : item.name}</Typography>
              </MenuItem>
            } else {
              return <MenuItem key={item.id} value={item.id} sx={{ display: 'flex', alignItems: 'center' }} >
                <div className='m-item-color' style={{ backgroundColor: item.colorhex, width: isMobile ? 15 : 5, height: 15, borderRadius: 5, float: 'left' }}></div>
                <Typography variant='inherit' noWrap style={{ paddingLeft: 5, fontSize: '1.1em' }}>{item.title ? item.title : item.name}</Typography>
              </MenuItem>
            }
          })}
        </Select>
      </FormControl>
    </div>
  );
}

SimpleSelectWithConfirmationColor.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  stateName: PropTypes.string,
  changeSelect: PropTypes.func,
  selected: PropTypes.number,
  disabled: PropTypes.bool
};
